
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="servicedesk_dialog mail-dialog">
  <div class="mail__dialog-header mobile_header">
    <div>
      <button id="mobile_sidebar_about_service_backbtn" mat-button (click)="close()">
        <mat-icon class="disable-select">chevron_left</mat-icon>
      </button>
    </div>
    <div id="mobile_sidebar_about_service_header" class="header_lbl disable-select">
      {{ headerText }}
    </div>
    <div class="submit"></div>
  </div>
  <div class="mail__dialog-header desktop_view">
    <div>
      <button mat-button>
        <mat-icon class="disable-select">headset_mic</mat-icon>
      </button>
    </div>
    <div class="header_lbl disable-select">
      {{ headerText }}
    </div>
    <div class="submit">
      <button mat-button (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="mail__dialog-body mail__dialog-body--pad">
    <div class="content">
      <p id="mobile_sidebar_about_service_text" class="text disable-select">
        {{ 'SERVICE_DESK_CONTENT' | translate }}
      </p>
      <p class="link">
        <a id="mobile_sidebar_about_service_serivebtn" target="_blank" class="open-new-window disable-select" href="{{serviceDeskURL}}">
          {{ buttonText }}
        </a>
      </p>
    </div>
  </div>
</div>